import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import { Theme } from './Theme'
import { AppRoutes } from './AppRoutes'
import { AuthProvider } from './providers'
import { SnackbarProvider } from 'notistack'
import { BrowserRouter } from 'react-router-dom'

export const App = (): JSX.Element => {
  return (
  // @mui/styles (JSS) と MUI v5 の Emotion のスタイル優先順位を調整する。
  // injectFirst により Emotion の style を先に挿入し、makeStyles で生成された CSS が後勝ちとなるようにする。
  // https://mui.com/material-ui/guides/interoperability/#controlling-priority-4
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={Theme}>
        <SnackbarProvider maxSnack={3}>
          <BrowserRouter>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
